<div class="container my-5">
    <br>
    <div class="row d-flex align-items-center justify-content-center">
        <div class="col-sm-12 col-md-4 col-lg-4">
            <img src="assets/img/logo-red.png" alt="Logotipo de Red de Salud Intercongregacional" class="img-fluid">
        </div>
        <div class="col-sm-12 col-md-8 col-lg-8">
            <h1>Mejorando la Salud de personas y comunidades  en la CDMX y Estado de México.</h1>
            <h3>Somos una Red tejida por congregaciones de mujeres consagradas. Creada en 2023, como <strong class="p-azul1">Red de Salud de Hermanas Católicas en México</strong> con el objetivo de unir a las congregaciones en torno a una misión en común: proporcionar servicios de salud integral a poblaciones desfavorecidas, en Ciudad de México y zonas rural de Estado de México.</h3>
        </div>
    </div>
    <br>
</div>